const ERROR_TOOLTIP_EVENT = 'invokeErrorTooltip';

const eventTarget = new EventTarget();

/**
 * Notify all subscribed tooltips about input errors.
 *
 * @param {object} errors - Map of field name to error content.
 */
export const emitErrorTooltip = errors => {
  eventTarget.dispatchEvent(new CustomEvent(ERROR_TOOLTIP_EVENT, { detail: errors }));
};

/**
 * Subscribe to input errors emitted by emitErrorTooltip.
 *
 * @param {Function} listener - Called with the errors map.
 * @returns {Function} Unsubscribe function.
 */
export const subscribeErrorTooltip = listener => {
  const handleEvent = event => listener(event.detail);

  eventTarget.addEventListener(ERROR_TOOLTIP_EVENT, handleEvent);

  return () => eventTarget.removeEventListener(ERROR_TOOLTIP_EVENT, handleEvent);
};
